import {Controller} from "@hotwired/stimulus"

// A segmented control and one pane per segment. Bootstrap's nav-tabs need their own
// JS and carry their own look, which is a different type scale and a different
// border from everything else on a redesigned screen.
//
// The active and inactive class lists are values rather than constants so the
// control can be a segmented switch on one screen and something else on the next.
export default class extends Controller {
    static targets = ["tab", "pane"]
    static values = {
        active: String,
        activeClass: {type: String, default: ""},
        inactiveClass: {type: String, default: ""}
    }

    connect() {
        this.show(this.activeValue || this.tabTargets[0]?.dataset.pane)
    }

    select(event) {
        event.preventDefault()
        this.show(event.currentTarget.dataset.pane)
    }

    show(name) {
        if (!name) return

        this.paneTargets.forEach((pane) => {
            pane.classList.toggle("ice:hidden", pane.dataset.pane !== name)
        })

        const active = this.activeClassValue.split(" ").filter(Boolean)
        const inactive = this.inactiveClassValue.split(" ").filter(Boolean)

        this.tabTargets.forEach((tab) => {
            const on = tab.dataset.pane === name
            tab.setAttribute("aria-selected", on)
            active.forEach((klass) => tab.classList.toggle(klass, on))
            inactive.forEach((klass) => tab.classList.toggle(klass, !on))
        })
    }
}
